/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import data from './data';
export default {
  mixins: [data],
  methods: {
    bulid_page: function bulid_page(pageSizeOptions, pageSize) {
      try {
        var option = eval('(' + pageSizeOptions + ')');
        if (pageSize) {
          this.pageSize = parseInt(pageSize);
        }
        if (option.length > 0) {
          this.pageSizeOpts = option;
        }
      } catch (err) {}
    },
    multi_col_set: function multi_col_set() {
      this.multiColSetShow = !this.multiColSetShow;
    },
    change_page: function change_page(page) {
      this.query_grid_data(page);
      this.renderData = [];
      this.currentStart = 0;
      //  this.initScrollContainer()
    },
    change_aage_size: function change_aage_size(pageSize) {
      this.pageSize = pageSize;
      this.query_grid_data();
      this.renderData = [];
      this.currentStart = 0;
      //  this.initScrollContainer()
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/mixins/page.js
// module id = 65
// module chunks = 0